import React from 'react';
import { CheckCircle } from 'lucide-react';
import { doctorInfo, qualifications } from '../data/mock';

const About = () => {
  return (
    <section id="sobre-mi" className="py-24 bg-gradient-to-b from-[#3D2418]/8 via-[#3D2418]/4 to-white relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#7DAAAF]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#3D2418]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative animate-slide-left">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-500 bg-gradient-to-br from-gray-100 to-white">
              <img 
                src="https://customer-assets.emergentagent.com/job_7076a617-eb4c-4673-b0a9-9b4684b6a985/artifacts/uq1nhgzf_IMG_2290.jpg"
                alt={doctorInfo.name}
                className="w-full h-[700px] object-cover object-top"
              />
              
              {/* Professional badge overlay */}
              <div className="absolute bottom-8 left-8 right-8">
                <div className="glass-dark rounded-2xl p-6 backdrop-blur-xl border border-white/10 shadow-2xl">
                  <p className="text-2xl md:text-3xl font-bold text-white mb-2">{doctorInfo.name}</p>
                  <p className="text-[#7DAAAF] font-semibold text-lg mb-1">{doctorInfo.specialty}</p>
                  <p className="text-gray-300 text-sm">{doctorInfo.collegiateNumber}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="animate-slide-right">
            <div className="space-y-6 mb-10">
              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
                Soy el Dr. Carlos Sanz Martín, médico especialista en Medicina Familiar y Comunitaria. 
                Mi vocación es ofrecer una atención de calidad, cercana y profesional en el entorno 
                más cómodo para el paciente: su propio hogar.
              </p>

              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
                Con más de 25 años de experiencia, he desarrollado una profunda comprensión de las 
                necesidades de mis pacientes, especialmente aquellos con movilidad reducida, personas 
                mayores o familias con niños pequeños que valoran la comodidad y seguridad de una 
                consulta domiciliaria.
              </p>
            </div>

            {/* Qualifications Cards */}
            <div className="grid gap-4">
              {qualifications.map((qual, index) => (
                <div 
                  key={index} 
                  className="bg-gradient-to-r from-white to-gray-50 border-2 border-gray-100 rounded-xl p-5"
                >
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-[#7DAAAF] to-[#6a959a] rounded-lg flex items-center justify-center mr-4">
                      <CheckCircle className="w-5 h-5 text-white" />
                    </div>
                    <p className="text-[#3D2418] font-medium leading-relaxed">
                      {qual}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
